import {
  createCredentialRequestSchema,
  credentialEnvelopeSchema,
  credentialListEnvelopeSchema,
  type CreateCredentialRequest,
  type CredentialResponse,
} from '@emr/shared';

import { apiRequest } from './client.ts';

export type { CredentialResponse, CreateCredentialRequest };

/** `GET /api/profile/credentials` — the caller's own credentials. Self-service, no capability. */
export async function listOwnCredentials(
  signal?: AbortSignal,
): Promise<readonly CredentialResponse[]> {
  const response = await apiRequest(
    '/api/profile/credentials',
    credentialListEnvelopeSchema,
    signal === undefined ? {} : { signal },
  );
  return response.credentials;
}

/** `POST /api/profile/credentials` — add one of the caller's own credentials. Self-reported, per
 * `server/src/auth/credentialsRoutes.ts`'s own header. */
export async function createOwnCredential(
  input: CreateCredentialRequest,
): Promise<CredentialResponse> {
  const body = createCredentialRequestSchema.parse(input);
  const response = await apiRequest('/api/profile/credentials', credentialEnvelopeSchema, {
    method: 'POST',
    body,
  });
  return response.credential;
}
